import { db } from "../firebase/config";
import { doc, updateDoc } from "firebase/firestore";

// Approve faculty function
export const approveFaculty = async (facultyId) => {
  const facultyRef = doc(db, "users", facultyId);  // Correct path to refer to the user document
  return updateDoc(facultyRef, { approved: true });
};

// Disable faculty function
export const disableFaculty = async (facultyId) => {
  const facultyRef = doc(db, "users", facultyId);  // Correct path to refer to the user document
  return updateDoc(facultyRef, { disabled: true });
};
